module.exports = __webpack_public_path__ + "static/media/fight_img.f993eccd.jpg";